// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","researchPerformanceTable":"Gb4hOy9ZC__mfLA24eJc3"};